import { render } from "./AddTeamView.vue?vue&type=template&id=0ed794b6&scoped=true"
import script from "./AddTeamView.vue?vue&type=script&lang=js"
export * from "./AddTeamView.vue?vue&type=script&lang=js"

import "./AddTeamView.vue?vue&type=style&index=0&id=0ed794b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed794b6"]])

export default __exports__